import { vendorCommissionBandSerializeMap } from "lib/serializers/vendorCommissionBands";
import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

import { addressSerializeMap } from "./address";
import {
  billingSettingsSerializeMap,
  nestedBillingSettingsSerializeMap,
} from "./billingSettings";
import { baseInterestSettingsSerializeMap } from "./interest";
import { tradingTermSerializeMap } from "./tradingTerms";

export const deploymentSettingsSerializeMap = {
  id: "id",
  eContractType: "econtract_type",
  physicalAddress: addressSerializeMap,
  splitEContractDocuments: "split_econtract_documents",
};

export const validationOverridesSerializeMap = {
  excludeSaleSubTypes: "exclude_sale_sub_types",
  headThreshold: "head_threshold",
  validationLevel: "validation_level",
  validationName: "validation_name",
};

export const deploymentSerializeMap: SerializeMap<Deployment> = {
  allowBusinessRelations: "allow_business_relations",
  billingSettings: billingSettingsSerializeMap,
  buyerTerms: "buyer_terms",
  channel: "channel",
  code: "code",
  corporateColor: "corporate_color",
  defaultDebtorInsurance: "default_debtor_insurance",
  deploymentSettings: deploymentSettingsSerializeMap,
  id: "id",
  interestSettings: baseInterestSettingsSerializeMap,
  tradingTerms: tradingTermSerializeMap,
  livestockAgencyId: "livestock_agency_id",
  locations: "locations",
  logo: "logo",
  name: "name",
  species: "species",
  validationOverrides: validationOverridesSerializeMap,
  vendorCommissionBands: vendorCommissionBandSerializeMap,
  vendorTerms: "vendor_terms",
  permissions: "permissions",
  // Pass throughs.
  avatar_url: "avatar_url",
  bidder_registration_logo_url: "bidder_registration_logo_url",
  clearing_sale_media_watermark_url: "clearing_sale_media_watermark_url",
  default_interstate_transit_insurance: "default_interstate_transit_insurance",
  default_transit_insurance: "default_transit_insurance",
  media_watermark_url: "media_watermark_url",
  placards_logo_url: "placards_logo_url",
  report_logo_url: "report_logo_url",
  sale_watcher_logo_url: "sale_watcher_logo_url",
};

const nestedDeploymentSerializeMap = {
  ...nestedBillingSettingsSerializeMap,
  deployment_settings: "deploymentSettings",
  billing_settings: "billingSettings",
  debtor_insurance: "debtorInsurance",
  physical_address: "physicalAddress",
  validation_overrides: "validationOverrides",
  vendor_commission_bands: "vendorCommissionBands",
  trading_terms: "tradingTerms",
  interest_settings: "interestSettings",
};

export const deserializeDeployment = buildDeserializer(
  deploymentSerializeMap,
  "deployment",
  nestedDeploymentSerializeMap,
);

export const serializeDeployment = buildSerializer(
  deploymentSerializeMap,
  "deployment",
  nestedDeploymentSerializeMap,
);
